import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEvent } from '../../../models/index';
import { CreateEventState } from '../../actions/types/events/CreateEventTypes';

/**
 * Initial Event state in store
 */
const initialState: CreateEventState = {
  isLoading: false,
  success: false,
  errorMessage: '',
  eventData: {
    uuid: '',
    status: '',
    version: '0',
    createdBy: '',
    dataEncryption: false,
    createdTimestamp: '',
    updatedBy: '',
    updatedTimestamp: '',
    eventName: '',
    eventDescription: '',
    eventType: '',
    eventCategory: '',
    schema: '',
    eventStatusHistory: [],
    sensitiveFields: [],
    eventSchemaId: '',
    eventSchemaVersion: '1'
  }
};

/**
 * Create Event Slice to create new Event
 */
const createEventsSlice = createSlice({
  name: 'createEvents',
  initialState,
  reducers: {
    createEventStarted: (state) => {
      state.isLoading = true;
    },

    createEventSuccess: (state, action: PayloadAction<IEvent>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.eventData = action.payload;
    },

    createEventFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.eventData = initialState.eventData;
    },

    updateEventSuccess: (state, action: PayloadAction<IEvent>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.eventData = action.payload;
    },

    updateEventFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.eventData = initialState.eventData;
    },

    clearEvent: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.eventData = initialState.eventData;
    },
  }
});

export const { createEventStarted, createEventSuccess, createEventFail, clearEvent, updateEventSuccess, updateEventFail } = createEventsSlice.actions;
export default createEventsSlice.reducer;
